import { ReactNode, FC, createContext, useState, useMemo } from 'react';
import * as types from '@models/types';

type HeatMapContextType = {
    heatMapData?: types.HeatMapDataTypes[] | undefined;
    setHeatMapData?: React.Dispatch<React.SetStateAction<types.HeatMapDataTypes[] | undefined>>;

};

const HeatMapContext = createContext<HeatMapContextType>({});


type HeatMapProps = {
    children: ReactNode;
};

const HeatMap: FC<HeatMapProps> = ({ children }) => {
    const [heatMapData, setHeatMapData] = useState<types.HeatMapDataTypes[] | undefined>([]);


    const HeatMapProviderValue = useMemo(
        () => ({
            heatMapData, setHeatMapData
        }),
        [heatMapData, setHeatMapData]
    );

    return (
        <HeatMapContext.Provider value={HeatMapProviderValue}>
            {children}
        </HeatMapContext.Provider>
    );
};

export { HeatMap, HeatMapContext };